export default __webpack_public_path__ + "static/media/starter_screen_icon_gradient.4ee4c190.svg";